export const Loader = () => {
  return (
    <div className="mainLoader">
      <img
        style={{ height: 150, width: 150 }}
        src={require("../../assets/images/Loading-Anim-MediumGray.gif")}
      />
    </div>
  );
};
